<template>
  <strong class="strong-title" :class="{ 'd-block': block }">
    {{ title }}
  </strong>
</template>

<script>
export default {
  name: 'StrongTitle',
  props: {
    title: {
      type: String,
      required: true,
    },
    block: {
      type: Boolean,
      default: () => false,
    },
  },
};
</script>

<style scoped>
.strong-title {
  text-align: left;
  font: Bold 16px/21px Lato;
  letter-spacing: 0;
  color: #11291b;
  opacity: 1;
}
</style>
